import { container } from '../modules/container';
import type { KeyedCursor, Structure } from '../../types/immstruct';

export default class InfoPanelService {
  show(type: string, props: Record<string, unknown> = {}) {
    container.get<Structure>('structure').cursor<KeyedCursor>(['ui', 'infoPanel']).merge({
      isVisible: true,
      component: type,
      props: props,
    });
  }

  hide() {
    container.get<Structure>('structure').cursor<KeyedCursor>(['ui', 'infoPanel']).merge({
      isVisible: false,
    });
  }
}
